////////////// JQUERY CONFLICT NO PLEASE

///////////////////////////////////////////
///////     COMMONS FUNCTIONS     /////////
///////////////////////////////////////////
(function ($) {

    // debug
    window.debug = window.debug || function(log) {
        if (typeof(log) === 'undefined') return;
        if ((typeof (window.console) !== 'undefined') && (typeof (console.log) === 'function')) {
            console.log(log);
        }
    };

    // check if object is empty
    window.isEmpty = function(obj) {

        // null and undefined are "empty"
        if (obj == null) return true;

        // Assume if it has a length property with a non-zero value
        // that that property is correct.
        if (obj.length > 0)    return false;
        if (obj.length === 0)  return true;

        // If it isn't an object at this point
        // it is empty, but it can't be anything *but* empty
        // Is it empty?  Depends on your application.
        if (typeof obj !== "object") return true;

        // Otherwise, does it have any properties of its own?
        // Note that this doesn't handle
        // toString and valueOf enumeration bugs in IE < 9
        for (var key in obj) {
            if (hasOwnProperty.call(obj, key)) return false;
        }

        return true;
    };

    // Main slideshow
    window.detectIE = window.detectIE || function() {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }
    };

    /*  concat values offering */
    window.concatValues = window.concatValues || function(obj){
        var value = '';
        for (var prop in obj) {
            value += obj[prop];
        }
        return value;
    };

    // check for mobiles and tablets
    window.refresh_size_queries = window.refresh_size_queries || function() {
        var classes = [];
            // var window_width = jQuery(window).width();
            // var window_height = jQuery(window).height();

            // window.is_phone = (window_width < 768);
            window.is_phone = (window.matchMedia("(max-width: 767px)").matches);
            // window.is_mobile = (window_width < 992);
            window.is_mobile = (window.matchMedia("(max-width: 991px)").matches);
            // window.is_tablet_portrait = (window_width >= 768 && window_width < 992);
            window.is_tablet_portrait = (window.matchMedia("(min-width: 768px) and (max-width: 991px)").matches);
            // window.is_tablet_landscape = (window_width >= 992 && window_width < 1200 && window_height <= 768);
            window.is_tablet_landscape = (window.matchMedia("(min-width: 768px) and (max-width: 991px and max-height: 768px)").matches);
            window.is_tablet = is_tablet_portrait || is_tablet_landscape;
            // window.is_desktop = (window_width >= 992);
            window.is_desktop = (window.matchMedia("(min-width: 992px)").matches);
            // window.is_desktop_large = (window_width >= 1200);
            window.is_large_desktop = (window.matchMedia("(min-width: 1200px)").matches);

            if (window.is_phone) {
                classes.push('mq_phone');
            }
            if (window.is_mobile) {
                classes.push('mq_mobile');
            }
            if (window.is_tablet_portrait) {
                classes.push('mq_tablet_portrait');
            }
            if (window.is_tablet_landscape) {
                classes.push('mq_tablet_landscape');
            }
            if (window.is_tablet) {
                classes.push('mq_tablet');
            }

            jQuery('html')
                .removeClass('mq_phone')
                .removeClass('mq_mobile')
                .removeClass('mq_tablet_portrait')
                .removeClass('mq_tablet_landscape')
                .removeClass('mq_tablet')
                .addClass(classes.join(' '));
    };

    // Resized 2.0 : keeps original image aspect ratio and centers image;
    window.resize_images = window.resize_images || function(divs) {
        var boxes = jQuery('[data-resize=true]');
        if (boxes.length == 0) {
            if (typeof(divs) === 'undefined') return;
            boxes = jQuery(divs);
        }

        if (boxes.length > 0) {
            jQuery.each(boxes, function (index, selector) {
                var box = $(this);
                box.imagesLoaded()
                    .progress(function (instance, image) {

                    })
                    .always(function (instance) {

                    })
                    .done(function (instance) {
                        var screen_width = box.outerWidth();
                        var screen_height = box.outerHeight();
                        var img = box.find('img');
                        var img_w = img.outerWidth();
                        var img_h = img.outerHeight();
                        var image_w = (typeof (img_w) !== 'undefined') ? img_w : box.data('img_width');
                        var image_h = (typeof (img_h) !== 'undefined') ? img_h : box.data('img_height');
                        var imageWRatio = image_w / image_h;
                        var imageHRatio = image_h / image_w;
                        var res_w;
                        var res_h;
                        var res_ox;
                        var res_oy;
                        // debug
                        // debug('resize .' + box.attr('class') + ' w:' + image_w + ' h:' + image_h);
                        if ((res_h = screen_height) && (res_w = res_h * imageWRatio) >= screen_width) {
                            ;
                        }
                        else {
                            if ((res_w = screen_width) && (res_h = res_w * imageHRatio) >= screen_height) {
                                ;
                            }
                        }
                        res_ox = (res_w == screen_width ? 0 : '-' + ((res_w - screen_width) / 2));
                        res_oy = (res_h == screen_height ? 0 : '-' + ((res_h - screen_height) / 2));

                        img.css({
                            'width': res_w + 'px',
                            'height': res_h + 'px',
                            'left': res_ox + 'px',
                            'top': res_oy + 'px'
                        });
                    })
                    .fail(function () {
                    });

            });
        }
    };

    // selects
    window.select_dd = window.select_dd || function(param) {
        // vars
        var select_wrappers = $('.select-wrapper');
        // check
        if(select_wrappers.length==0) return;
        // select wrappers
        select_wrappers.each(function () {
            var sel_wrap = $(this);
            var sel_input = sel_wrap.data('inputname');
            var sel_callback = sel_wrap.data('callback');
            var sel_label = sel_wrap.find('.select-label');
            var sel_dbox = sel_wrap.find('.select-dropdown-box');
            var sel_d = sel_wrap.find('.select-dropdown');
            var sel_opts = sel_wrap.find('.select-option');
            sel_label.on('click tap', function () {
                // debug($(this));
                if (sel_wrap.hasClass('opened')) {
                    // debug('close');
                    sel_dbox.animate({
                        height: 0
                    }, 300, function () {
                        sel_wrap.removeClass('opened');
                    });
                } else {
                    // debug('open');
                    // i want to check
                    var h = sel_d.outerHeight();
                    // if the top of the dd menu goes upper than i scroll (minus header) i want that down
                    if(  parseInt(sel_wrap.offset().top-h,10) < parseInt(jQuery(window).scrollTop()+jQuery('#header').outerHeight(),10) ){
                        // debug(parseInt(sel_wrap.offset().top-h,10));
                        // debug(parseInt(jQuery(window).scrollTop()+jQuery('#header').outerHeight()));
                        // debug('add below');
                        sel_wrap.addClass('below');
                    } else {
                        // debug('remove below');
                        sel_wrap.removeClass('below');
                    }
                    sel_dbox.animate({
                        height: h
                    }, 300, function () {
                        sel_wrap.addClass('opened');
                    });
                }
            });
            sel_opts.each(function(){
                $(this).on('click',function(){
                    // reset class
                    sel_d.find('.active').removeClass('active');
                    // take value
                    var val = $(this).data('value');
                    // put value on label
                    sel_label.html('<span>'+$(this).html()+'</span>');
                    // add class
                    $(this).addClass('active');
                    // animate menu
                    sel_dbox.animate({
                        height: 0
                    },300, function() {
                        // put value in inputs
                        $('input[name='+sel_input+']').val(val);
                        sel_wrap.removeClass('opened');
                    });
                    // check if it exist and fire it
                    if(typeof(window[sel_callback])!=='undefined'){
                        window[sel_callback](sel_d,val);
                    }
                });
            });
        });

        $(document).on('click',function (event) {
            if (  !$(event.target).closest('.select-wrapper').length
                // && !$(event.target).closest('#inline-datepicker_placeholder').length
                // && !$(event.target).closest('#booking_form_placeholder .dates').length
            ) {
                // let's close it
                select_wrappers.each(function(){
                    var select_wrapper = $(this);
                    if(select_wrapper.hasClass('opened')){
                        var sel_dbox = select_wrapper.find('.select-dropdown-box');
                        // debug('close');
                        sel_dbox.animate({
                            height: 0
                        }, 300, function () {
                            select_wrapper.removeClass('opened');
                        });
                    }
                });
            }
        });
    };

    //  openclose content
    window.opencloseviewmore = window.opencloseviewmore || function() {
        var button_readmore = $('.view_more_content');

        button_readmore.on('click tap', function(e) {
            e.stopPropagation();
            // this
            var anchor = $(this);
            var div_id = anchor.data('id');
            // id optional
            var more_text_box = (typeof div_id !== 'undefined') ? $('#'+div_id) : $(this).parent().find('.more_text_box');
            // reset
            if(typeof div_id == 'undefined'){
                var more_text_box_opened = $('.more_text_box.opened');
                if (more_text_box_opened.length > 0) {
                    more_text_box_opened.stop().animate({height: 0}, 300, function () {
                        more_text_box_opened.parent().find('.view_more_content').removeClass('opened');
                        more_text_box_opened.removeClass('opened');
                    });
                }
            }
            if ($(this).hasClass('opened')) {
                more_text_box.stop().animate({height: 0}, 300, function () {
                    anchor.removeClass('opened');
                    more_text_box.removeClass('opened');
                });
            } else {
                var customHeight = more_text_box.find('.more_text').outerHeight(true);
                more_text_box.stop().animate({height: customHeight}, 300, function () {
                    anchor.addClass('opened');
                    more_text_box.addClass('opened');
                });
            }
            //close on btn
            more_text_box.find('.close').on('click tap',function(){
                more_text_box.stop().animate({height: 0}, 300, function () {
                    anchor.removeClass('opened');
                    more_text_box.removeClass('opened');
                });
            });
        });
        var button_popup = $('.view_pop_up');
        button_popup.click(function (e) {
            e.stopPropagation();
            var html = button_popup.closest('.popup_content').find('.more_text_box').html();
            $.fancybox.open(html);
        });
    };

    // scrolling
    window.scroll_to = window.scroll_to || function(param) {
        var top = 0;
        if (typeof(param) == 'string') {
            var target = jQuery(param);
            if (target.length) {
                top = target.offset().top;
            }
        } else if (typeof(param) == 'number') {
            top = param;
        }
        window.scrollFromJQuery = true;
        jQuery('html,body').stop(true).animate(
            {
                scrollTop: top - $('#header').height() + 1
            },
            500,
            'swing',
            function () {
                window.scrollFromJQuery = false;
            }
        );
    };

    // scrolling 2
    window.btn_scroll = window.btn_scroll || function(){
        var btns = $('.scroll_to');
        var offset = 0;
        if(btns.length==0) return;
        if($('#breadcrumb').length>0) offset = $('#breadcrumb').outerHeight();
        btns.each(function(){
            var btn = $(this);
            btn.on('click',function(e){
                e.preventDefault();
                var hash = $(this).attr('href');
                if($(hash).length==0) return;
                $('.scroll_to.active').removeClass('active');
                setTimeout(function(){
                    $('html,body').animate({
                        scrollTop: $(hash).offset().top-$('#header').outerHeight()-offset
                    },1000,function(){
                    });
                    btn.addClass('active');
                },100);
            });
        });
    };

    // lazy load
    window.lazy = window.lazy || function(){
        // check
        if(jQuery('.lazy').length===0) return false;
        // initialize lazy
        window.myLazyLoad = new LazyLoad({
            elements_selector: ".lazy"
        });
    };


    /////// END GENERAL FUNCTIONS


    //////// THEME FUNCTIONS //////////


    // function for scrolling header;
    window.header_scroll = window.header_scroll || function() {
        // elems
        var booking_form_wrap = jQuery("#booking_form_wrap");
        var header = jQuery("#header");
        // var offset = -jQuery("#header").outerHeight()-50;
        var offset = 0;
        // var mobile = jQuery("#mobile_bottom_bar");
        // waypoint
        var waypoint; //// header_wrap.outerHeight(true)
        waypoint = (booking_form_wrap.length > 0) ? parseInt(booking_form_wrap.offset().top + offset) : 0;
        // header check and remove or add !window.is_mobile &&
        if (jQuery('body').hasClass('home')) {
            // if i have scrolled more than header wrapper on home
            if (waypoint != 0 && jQuery(window).scrollTop() >= waypoint) {
                header.removeClass('home_top');
            } else {
                header.addClass('home_top');
            }
            // mobile
            if(window.is_mobile) {
                header.removeClass('home_top');
            }
        }
    };

    // function that controls the height of slideshow
    window.slideshowHeight = window.slideshowHeight || function() {
        var sshow_wrap = jQuery('#slideshow_wrapper');
        if (sshow_wrap.length === 0) return;
        //vars
        var header_wrapper_h = jQuery('#header_wrapper').height();
        var window_h = jQuery(window).height();
        // var height = parseInt((window_h-header_wrapper_h-200),10);
        var height = parseInt((window_h * 0.7),10);
        var max_height =  parseInt((window_h - header_wrapper_h - 200),10);
        var min_height = 350;

        // if is tablet and portrait
        if(!$('body.homepage').hasClass('home-customized')){
            if(window.is_tablet_portrait) {
                height = 340;
                min_height = height;
                max_height = height;
            }
            // if is phone
            if (window.is_phone) {
                height = 200;
                min_height = height;
                max_height = height;
            }
        }
        // homepage
        if(!$('body.homepage').hasClass('home-customized')){
            if (sshow_wrap.hasClass('homepage')) {
                max_height = height;
                if(window.is_mobile || window.is_phone) {
                    height = parseInt((window_h - header_wrapper_h - $('#mobile_bottom_bar').height()),10);
                    max_height = height;
                } else {
                    sshow_wrap.removeAttr('style');
                    return;
                }
            }
        }
        // putting height!
        if(!$('body.homepage').hasClass('home-customized')){
            sshow_wrap.css({
                height: height ,
                'max-height': max_height,
                'min-height': min_height
            });
        }
    };

    // Post-loads images and starts slideshow
    window.doSlideshow = window.doSlideshow || function(imagesContainerSelector) {
        if(typeof jQuery(imagesContainerSelector) == 'undefined' || jQuery(imagesContainerSelector).size()==0 ) return false;
        if (typeof(sshow_image_data) !== 'undefined' && sshow_image_data.length > 0) {
            // global
            numberOfSlides = sshow_image_data.length;
            var link =  '';
            // config
            var ss_speed = (typeof(slide_speed) !== 'undefined' && jQuery.trim(slide_speed) !== '') ? slide_speed : 1500;
            var ss_timeout = (typeof(slide_timeout) !== 'undefined' && jQuery.trim(slide_timeout) !== '') ? slide_timeout : 3000;
            var loading = jQuery('.loading_sshow');
            // calculating size
            var breakpoints = [];
            var current_breakpoint = 'max';
            var ww = $(window).width();
            var sizes = sshow_image_data[0].url_set;

            //
            for (var i in sizes) {
                if (sizes.hasOwnProperty(i)) {
                    if (i !== 'default' && i!=='max') {
                        breakpoints.push(parseInt(i,10));
                    }
                }
            }
            if (breakpoints.length > 0) {
                breakpoints.sort(function(a,b){ return a - b; });
                for (var k = 0; k < breakpoints.length; k++) {
                    if (ww < breakpoints[k]) {
                        current_breakpoint = breakpoints[k];
                        break;
                    }
                }
            }

            $.each(sshow_image_data, function (index, imgset) {
                // images set
                var urls = imgset['url_set'];
                // do the other images
                var id = imgset['ID'];
                var img = jQuery('<img/>').attr('src', urls[current_breakpoint]).attr('alt', imgset['title']);
                var slider = jQuery('<div class="slide"/ data-id="'+id+'" >');
                slider.append($('<noscript>').append(img));
                slider.css('background-image', 'url('+urls[current_breakpoint]+')');
                // if there is a page selected
                if( !jQuery.isEmptyObject(imgset['page_selected']) ){

                    var link = '<a class="button border white" href="'+imgset['page_selected'].url+'">'+imgset['page_selected'].title+'</a>';
                }
                if (typeof imgset['caption_title'] !== 'undefined' || imgset['caption_title'] !== '' || typeof imgset['caption_subtitle'] !== 'undefined' ||  imgset['caption_subtitle'] !== '') {
                    var caption_title = (typeof imgset['caption_title'] !== 'undefined' && imgset['caption_title'] !== '') ? '<div class="caption_title">' + imgset['caption_title'] + '</div>' : '';
                    var caption_subtitle = (typeof imgset['caption_subtitle'] !== 'undefined' && imgset['caption_subtitle'] !== '') ? '<div class="caption_subtitle">' + imgset['caption_subtitle'] + '</div>' : '';
                    var caption_content = jQuery('<div class="caption_content" />').append(caption_title).append(caption_subtitle).append(link);
                    var caption = jQuery('<div class="caption hidden-xs '+imgset['caption_class']+'" />').append(caption_content);
                    slider.append(caption);
                }
                $(imagesContainerSelector).append(slider);

            });

            // resize ss box
            slideshowHeight();

            //  sshowwww
            var sshow = jQuery(imagesContainerSelector);
            if (sshow_image_data.length == 1) {
                if(loading.length!=0){
                    loading.fadeOut(2000);
                }
            } else {
                if (!sshow.hasClass('slick-initialized')) {
                    // On init event
                    sshow.on('init', function(event, slick, direction){
                        if(loading.length!=0){
                            loading.fadeOut(2000);
                        }
                    });
                    sshow.slick({
                        slidesToShow: 1,
                        autoplay: true, /* TODO sistemare autoplay*/
                        autoplaySpeed: ss_timeout,
                        speed: ss_speed,
                        fade: true,
                        cssEase: 'linear',
                        nextArrow: sshow.parent().find('.arrow.next'),
                        prevArrow: sshow.parent().find('.arrow.prev')
                    });
                }
            }
        }
    };

    // open the menu
    window.lang_menu_open = window.lang_menu_open || function() {
        var btn = jQuery('#languages_btn a');
        var langs_box = jQuery('#languages_box');
        if (btn.length === 0 || langs_box.length === 0) return;
        var overlay = jQuery('#languages_box_overlay');
        var mClass = ('visible');
        var htmlClass = ('noscroll');
        var html = jQuery('html');

        // open
        btn.on('click tap',function () {
            if (!langs_box.hasClass(mClass)) {
                langs_box.addClass(mClass);
                overlay.addClass(mClass);
                html.addClass(htmlClass);
            }
        });
        // close
        $(document).on('click tap','#languages_box_overlay , .close_lang',function () {
            if (langs_box.hasClass(mClass)) {
                langs_box.removeClass(mClass);
                overlay.removeClass(mClass);
                html.removeClass(htmlClass);
            }
        });
    };

    // open the bf button
    window.open_bf_btn = window.open_bf_btn || function() {
        // elems
        var window_w = jQuery(window).outerWidth();
        var open_booking = jQuery("#open_booking");
        var slideshow_wrapper = jQuery("#slideshow_wrapper");
        var header_container = jQuery("#header .header_container");
        var header_bar = jQuery("#header .header_bar");

        // offset
        var offset = 0;

        // waypoint
        var waypoint;
        waypoint = (slideshow_wrapper.length > 0) ? parseInt(slideshow_wrapper.outerHeight(true) + offset) : 0;

        // NOT in mobile or portrait
        if(!window.is_mobile) {
            // if i have scrolled more than slideshow i open the btn
            if (waypoint !== 0 && jQuery(window).scrollTop() >= waypoint) {
                open_booking.addClass('opened');
            } else {
                open_booking.removeClass('opened');
            }

        }
        // only tablet is opened everytime
        if(window.is_mobile){
            open_booking.addClass('opened');
        }

        // no slideshow -> button is opened
        if (slideshow_wrapper.length === 0) {
            open_booking.addClass('opened');
        }

        // dynamic padding
        var right_padding = 0;
        if(open_booking.hasClass('opened')){
            // i want to calculate the overflow part of the btn
            var open_booking_w = open_booking.outerWidth();
            var right_margin = parseInt( (window_w-header_container.outerWidth())/2 ,10);

            right_padding = parseInt( open_booking_w-right_margin,10);
        }
        // mobile
        if(window.is_mobile){
            right_padding = 0;
        }
        header_bar.css({
            'padding-right': right_padding+'px'
        });

    };

    // open the menu
    window.mobile_menu_open = window.mobile_menu_open || function() {
        var btn = jQuery('a#open_menu_mobile');
        var sidebar = jQuery('#mobile_menu_wrapper');
        if (btn.length === 0 || sidebar.length === 0) return;
        var sidebar_overlay = jQuery('#mobile_menu_overlay');
        var mClass = ('visible');
        var htmlClass = ('noscroll');
        var html = jQuery('html');

        // open
        btn.on('click tap',function () {
            if (!sidebar.hasClass(mClass)) {
                sidebar.addClass(mClass);
                sidebar_overlay.addClass(mClass);
                html.addClass(htmlClass);
                if($(window).width()<350){
                    sidebar.width($(window).width()).css('left','auto');
                }
            }
        });
        // close
        sidebar_overlay.on('click tap',function () {
            if (sidebar.hasClass(mClass)) {
                sidebar.removeClass(mClass);
                sidebar_overlay.removeClass(mClass);
                html.removeClass(htmlClass);
                if($(window).width()<350){
                    sidebar.css('left',-$(window).width());
                }
            }
        });
        // close
        jQuery('.close_sidebar').on('click tap',function () {
            if (sidebar.hasClass(mClass)) {
                sidebar.removeClass(mClass);
                sidebar_overlay.removeClass(mClass);
                html.removeClass(htmlClass);
                if($(window).width()<350){
                    sidebar.css('right',-$(window).width());
                }
            }
        });

    };

    // function for scrolling breadcrumb position
    window.breadcrumb_scroll = window.breadcrumb_scroll || function() {
        // elems
        var breadcrumb = jQuery("#breadcrumb");
        var breadcrumb_menu = jQuery("#breadcrumb_menu");
        if (breadcrumb.length === 0) return false;
        var header = jQuery("#header");
        // var ss = jQuery("#slideshow_wrapper");
        // var map = jQuery("#map_box");
        var offset = 0;
        // waypoint
        var waypoint = parseInt(breadcrumb.offset().top -header.outerHeight() + offset,10); //// header_wrap.outerHeight(true)
        // // if i have SS
        // if(ss.length>0 || map.length>0){
        //     var waypoint_sel = false;
        //     // offset
        //     if(ss.length>0){
        //         waypoint_sel = ss;
        //     }
        //     if(map.length>0){
        //         waypoint_sel = map;
        //     }
        //     var offset = waypoint_sel.offset().top-header.outerHeight();
        //     waypoint =  parseInt(waypoint_sel.outerHeight(true) + offset,10) ;
        //
        // } else {
        //     waypoint =  parseInt(header.outerHeight(true),10) ;
        // }
        // if is not mobile
        if(!window.is_phone) {
            // if i have scrolled more than header wrapper on home
            if (waypoint !== 0 && jQuery(window).scrollTop() >= waypoint) {
                breadcrumb_menu.addClass('fixed');
            } else {
                breadcrumb_menu.removeClass('fixed');
            }
        } else {
            breadcrumb_menu.removeClass('fixed');
        }
    };

    // homepage offers
    window.carousel_offers = window.carousel_offers || function(){
        var item = $('.item_carousel');
        if (item.size() > 0) {
            item.each(function () {
                var myItem = $(this);
                var slickSettings =  {
                    slidesToShow: 3,
                    centerMode: false,
                    centerPadding: '0',
                    infinite: true,
                    dots: true,
                    nextArrow: myItem.parent().find('.arrow.next'),
                    prevArrow: myItem.parent().find('.arrow.prev'),
                    appendDots: myItem.parent().find('.pager'),
                    responsive: [
                        {
                            breakpoint: 1200,
                            settings: {
                                slidesToShow: 3
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1
                            }
                        }
                    ]
                };

                // if is home
                if (item.hasClass('special_offers') > 0) {
                    slickSettings.slidesToShow = 3;
                }
                myItem.slick(slickSettings);

            });

        }
    };

    // mobile
    window.carousel_offers_mobile = window.carousel_offers_mobile || function(){
            var items = $('.item_carousel_mobile');
            if (items.size() > 0) {
                items.each(function () {
                    var myItem = $(this);
                    if(window.is_mobile) {
                        myItem.slick({
                            slidesToShow: 1,
                            infinite: true,
                            dots: true,
                            nextArrow: myItem.parent().find('.arrow.next'),
                            prevArrow: myItem.parent().find('.arrow.prev'),
                            appendDots: myItem.parent().find('.pager')
                        });
                    } else {
                        if(myItem.hasClass('slick-initialized')){
                            myItem.slick('unslick');
                        }
                    }
                    // .slick('unslick');
                });
            }
        };

    // function for google map
    window.google_map = window.google_map || function() {
        // starting up map template-part
        if ((jQuery('#map_canvas').length > 0)) {
            // vars
            var map_triggered = false;
            var location = jQuery('#location');
            // if i am in hotel page
            if(location.length>0) {
                // check on scroll
                jQuery(window).scroll(function(){
                    // limit of the offers
                    var waypoint = location.offset().top;
                    if(jQuery(window).scrollTop() >= (waypoint-jQuery(window).height()) && !map_triggered ){
                        // checker
                        map_triggered = true;
                        // go map ( code is in child )
                        initializeMap('map_canvas', gmap_config);
                    }
                });
            } else {
                // checker
                map_triggered = true;
                // go map ( code is in child )
                initializeMap('map_canvas', gmap_config);
            }

            // travelmode selection
            var button_itinerary_mode = jQuery('.itinerary_mode');
            button_itinerary_mode.click(function (e) {
                e.stopPropagation();
                // this
                var anchor = $(this);
                // check
                if (anchor.hasClass('active')) return false;
                // reset
                jQuery('.itinerary_mode.active').removeClass('active');
                // adding class
                anchor.addClass('active');
            });

            // routing
            jQuery('#calculate').on('click', function () {
                calcRoute();
            });

            //this part handle the close_map button
            jQuery('.close_map').click(function () {
                jQuery('#map_directions').fadeOut(function () {
                    directionsDisplay.setPanel(null);
                    directionsDisplay.setMap(null);
                    map.setZoom(gmap_config.map_zoom);
                    if (gmap_config.set_bounds) {
                        map.fitBounds(gmap_config.bounds);
                    } else {
                        map.setCenter(new google.maps.LatLng(gmap_config.hotel_info.latitude, gmap_config.hotel_info.longitude));
                    }
                    var map_infobox = $('.map_infobox');
                    if (map_infobox.size() > 0 && !window.is_mobile) {
                        map_infobox.fadeIn();
                    }

                });
                jQuery('.itineraryPanelWrapper').remove();
            });
        }

    };

    // rooms gallery
    window.child_gallery = window.child_gallery || function() {
        // objs
        var child_galleries_box = $('.child_gallery_box');
        // check
        if (child_galleries_box.length === 0) return false;
        //go
        child_galleries_box.each(function () {
            var gallery = $(this).find('.child_gallery');
            // on done slick
            gallery.on('init', function(event){
                myLazyLoad.update();
            });
            gallery.on('beforeChange', function(event){
                myLazyLoad.update();
            });
            gallery.on('afterChange', function(event){
                myLazyLoad.update();
            });
            // go slick
            gallery.slick({
                slidesToShow: 1,
                infinite: false,
                dots: true,
                // lazyLoad:'progressive',
                // lazyLoad: 'ondemand',
                nextArrow: $(this).find('.next'),
                prevArrow: $(this).find('.prev'),
                appendDots: $(this).find('.pager')
            });



        });
    };

    // photogallery
    window.photogallery = window.photogallery || function() {
        var boxContainer = $('#photo_gallery');
        if (boxContainer.length === 0) return false;
        // isotope
        var $grid = $('.all_filter_gallery').isotope();
        // desktop
        $('.menu_filters').on('click tap', 'a', function () {
            $('.menu_filters a').removeClass('active');
            $(this).addClass('active');
            var filterValue = $(this).attr('data-filter');
            $grid.isotope({filter: filterValue});
        });
        // mobile
        $('.mobile_menu_filters select').on('change',function () {
            var filterValue = $(this).val();
            $grid.isotope({filter: filterValue});
        });
        $grid.on('arrangeComplete', function (event, filteredItems) {
            //
        });
    };

    //////////
    ////////// ONLY GROUP FUNCTIONS
    //////////

    window.group_boxes_carousel = window.group_boxes_carousel || function() {
        var boxes = $('.group_boxes_carousel');
        if (boxes.length  === 0) return false;

        boxes.each(function () {
            var box = $(this);
            box.slick({
                dots: false,
                infinite: true,
                speed: 300,
                slidesToShow: 3,
                centerMode: false,
                variableWidth: false,
                nextArrow: box.parent().find('.arrow.next'),
                prevArrow: box.parent().find('.arrow.prev'),
                responsive: [
                    {
                        breakpoint: 1400,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
                // appendDots: myItem.parent().find('.pager'),
            });
        });

    };

    // hotels list
    window.hotels_list = window.hotels_list || function() {
        var boxContainer = $('#hotels_preview');
        if (boxContainer.length === 0) return false;
        // menu selection
        var filters = {};
        var grid = $('.hotels_preview');
        // desktop
        $('.filter_box').on('click tap', '.select-option', function () {


            var button_group = $(this).parents('.filter_group');
            button_group.find('.selected').removeClass('selected');
            $(this).addClass('selected');
            var filter_group = button_group.attr('data-filter-group');
            filters[filter_group] = $(this).attr('data-filter');
            var filter_value = concatValues(filters);
            var visible = 0;
            if(grid.find('.box_wrap').not(filter_value).length>0) {
                grid.find('.box_wrap').not(filter_value).hide(400,function(){
                    grid.find(filter_value).show(400,function(){
                        visible++;
                    });
                });
            } else {
                grid.find(filter_value).show(400,function(){
                    visible++;
                });
            }

            if(grid.find(filter_value).length === 0){
                $('.advise').show();
            } else {
                $('.advise').hide();
            }

        });
    };

    // offers list
    window.group_offers_list = window.group_offers_list || function() {
        var boxContainer = $('#offers_list');
        if (boxContainer.length === 0) return false;
        // menu selection
        var filters = {};
        var grid = $('.offers_list');
        // desktop
        $('.filter_box').on('click tap', '.select-option', function () {
            // var filterValue = $(this).attr('data-filter');
            var $buttonGroup = $(this).parents('.filter_group');
            var filterGroup = $buttonGroup.attr('data-filter-group');
            filters[filterGroup] = $(this).attr('data-filter');
            var filterValue = concatValues(filters);
            var visible = 0;
            if(grid.find('.box_wrap').not(filterValue).length>0) {
                grid.find('.box_wrap').not(filterValue).hide(400,function(){
                    grid.find(filterValue).show(400,function(){
                        visible++;
                    });
                });
            } else {
                grid.find(filterValue).show(400,function(){
                    visible++;
                });
            }
            if(grid.find(filterValue).length === 0){
                $('.advise').show();
            } else {
                $('.advise').hide();
            }
        });
    };

    // group galleries
    window.group_galleries = window.group_galleries || function() {
        var boxContainer = $('#galleries');
        if (boxContainer.length === 0) return false;
        // menu selection
        var filters = {};
        var grid = $('.galleries_box');
        // desktop
        $('.filter_box').on('click tap', '.select-option', function () {
            var filterValue = $(this).attr('data-filter');
            // var $buttonGroup = $(this).parents('.filter_group');
            // var filterGroup = $buttonGroup.attr('data-filter-group');
            // filters[filterGroup] = $(this).attr('data-filter');
            // var filterValue = concatValues(filters);
            var visible = 0;
            if(grid.find('.thumb_wrap').not(filterValue).length>0) {
                grid.find('.thumb_wrap').not(filterValue).hide(400,function(){
                    grid.find(filterValue).show(400,function(){
                        visible++;
                    });
                });
            } else {
                grid.find(filterValue).show(400,function(){
                    visible++;
                });
            }
        });
    };

    // function to filter for the selects
    window.cluster_filter = window.cluster_filter || function(selector,val){
        var target_sel = $('.field_box.hotels');
        var sel_wrap = target_sel.find('.select-wrapper');
        var opts = target_sel.find('.select-option');
        var sel_d = target_sel.find('.select-dropdown');
        var sel_dbox = target_sel.find('.select-dropdown-box');
        opts.each(function(){
            if (val === global_data.data.fb_cluster_name){
                $(this).removeClass('hide');
            } else {
                var clusters = $(this).data('clusters');
                if($.inArray(val,clusters)!=='-1'){
                    // if in array is different than -1 i have a match so i can remove a class
                    $(this).removeClass('hide');
                } else {
                    // no match -> addclass
                    $(this).addClass('hide');
                }
            }
        });
        if(!sel_wrap.hasClass('opened')) return;
        var h = sel_d.outerHeight();
        //
        sel_dbox.animate({
            height: h
        }, 300, function () {
        });
    };

})(jQuery);
